import { PropsWithChildren } from 'react';

export function AuthHeader ({ children }: PropsWithChildren) {
  return (
    <h2 className="text-5xl font-semibold leading-[54px] tracking-[-0.02em] max-w-[500px]">
      {children}
    </h2>
  );
}
